import { render } from "./shopee.vue?vue&type=template&id=900d195a&scoped=true"
import script from "./shopee.vue?vue&type=script&lang=js"
export * from "./shopee.vue?vue&type=script&lang=js"

import "./shopee.vue?vue&type=style&index=0&id=900d195a&scoped=true&lang=css"

import exportComponent from "/Users/arissa/Desktop/code/portfolio/arissa-portfolio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-900d195a"]])

export default __exports__